"use strict";
exports.__esModule = true;
exports.ADDRESS_SELECTION = void 0;
exports.ADDRESS_SELECTION = {
    HEADER: 'Search for your property',
    BODY: 'If your property isn’t in our list, you may still be able to use Flex.',
    SEARCH_INPUT_LABEL: 'Search by property name or address',
    DONT_SEE_PROPERTY: 'My property isn’t listed',
    SEARCH_INPUT_PLACEHOLDER: 'Example: Shift apartments CA 90201',
    LOCATION_DATA: 'Use location to improve results'
};
